const getActiveOrganisations = (organisations)=>{
    return organisations.filter((org)=> org.isApproved === true)
}

export default getActiveOrganisations;